import axios from "./axios";
import * as Requests from "./requests";
import { ServiceDisablesPayload } from "../../../helpers/audit/utils";

export interface IToggleOrderingServices {
  delivery_branches_ids: string[];
  pickup_branches_ids: string[];
  drive_thru_branches_ids?: string[];
  scheduled_services?: ServiceDisablesPayload;
}

export const toggleOrderingServicesAPI = (
  token: string,
  data: IToggleOrderingServices
) => {
  return axios.put(Requests.toggleOrderingServices, data, {
    headers: {
      token,
    },
    baseURL: process.env.REACT_APP_PICKUP_ENDPOINT,
  });
};
